import {RouteDefinition} from '../../../routes';
import {MediaInputListScreen} from './MediaInputListScreen';
import {MediaInputEditScreen} from './MediaInputEditScreen';

export const MediaSettingsRoutes: RouteDefinition[] = [
    {
        name: 'Kumandalar',
        routerLink: '/settings/media',
        component: MediaInputListScreen,
    },
    {
        name: 'Kumanda Düzenle',
        routerLink: '/settings/media/edit/:id',
        component: MediaInputEditScreen,
    },
    {
        name: 'Kumanda Oluştur',
        routerLink: '/settings/media/edit',
        component: MediaInputEditScreen,
    },
];
